export const COLORS = [
  {
    texture: './model/c_leather.jpg',
    size: [1, 1, 1],
    normalMap: './model/c_normal.jpg',
    roughnessMap: './model/c_roughness.jpg',
  },
  {
    texture: './model/c_leather_d.jpg',
    size: [1, 1, 1],
    normalMap: './model/c_normal.jpg',
    roughnessMap: './model/c_roughness.jpg',
  },
  {
    texture: './model/velvet_blue.jpg',
    size: [1, 1, 1],
    normalMap: './model/c_normal.jpg',
    roughnessMap: './model/c_roughness.jpg',
  },
  {
    texture: './model/velvet_white.jpg',
    size: [1, 1, 1],
    normalMap: './model/c_normal.jpg',
    roughnessMap: './model/c_roughness.jpg',
  },
  {
    texture: './model/w_01.jpg',
    size: [1, 1, 1],
    normalMap: './model/w_normal.jpg',
    roughnessMap: './model/w_roughness.jpg',
  },
  {
    texture: './model/w_02.jpg',
    size: [1, 1, 1],
    normalMap: './model/w_normal.jpg',
    roughnessMap: './model/w_roughness.jpg',
  },
  {
    texture: './model/w_03.jpg',
    size: [1, 1, 1],
    normalMap: './model/w_normal.jpg',
    roughnessMap: './model/w_roughness.jpg',
  },
  {
    texture: './model/w_04.jpg',
    size: [1, 1, 1],
    normalMap: './model/w_normal.jpg',
    roughnessMap: './model/w_roughness.jpg',
  },
]
